import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const RadarIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M5.93794 1.5402C5.64436 1.0042 4.98536 0.813524 4.53835 1.21483C2.44513 3.09399 1.85548 6.33674 3.27947 8.9365C4.70347 11.5363 7.66257 12.6194 10.2531 11.6482C10.8063 11.4408 10.9792 10.7439 10.6856 10.2079L5.93794 1.5402Z"
		/>
		<path
			fill="currentColor"
			d="M13.3441 2.81158L6.29884 7.09904L4.5556 3.91643C6.07605 4.40564 9.96238 4.86957 13.3441 2.81158Z"
		/>
		<path
			fill="currentColor"
			d="M13.3441 2.81158L6.29884 7.09904L8.04209 10.2817C8.40038 8.64914 9.96238 4.86957 13.3441 2.81158Z"
		/>
		<path
			fill="currentColor"
			d="M12.9187 4.48496C12.3629 4.82323 11.6521 4.62248 11.3312 4.03658C11.0103 3.45068 11.2007 2.70148 11.7566 2.36321C12.3124 2.02494 13.0232 2.22568 13.3441 2.81158C13.665 3.39749 13.4746 4.14668 12.9187 4.48496Z"
		/>
		<path
			fill="currentColor"
			d="M3 15C3 13.8954 3.89543 13 5 13H11C12.1046 13 13 13.8954 13 15H3Z"
		/>
	</svg>
))
